export class SliderModel {
  title: number;
  color: string;
  image: string;
  smallImage: string;
  shortDescription: string;
  subLink: string;
  descFlag: boolean;
  buttonFlag: boolean;
  buttonAccessibilityText: string;
  eyeBrowText: string;
  captionBg: boolean;
  captionWhite: boolean;
  actionLabel: string;

  constructor() {
    this.title = undefined;
    this.color = undefined;
    this.image = undefined;
    this.smallImage = undefined;
    this.shortDescription = undefined;
    this.subLink = undefined;
    this.descFlag = undefined;
    this.buttonFlag =  undefined;
    this.buttonAccessibilityText = undefined;
    this.captionWhite = undefined;
    this.actionLabel = undefined;
  }
}
